import React from 'react';
import AppRouter from 'common/AppRouter';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import { ReactComponent as InvitationExpired } from 'images/invitation-expired.svg';
import { useHistory } from 'react-router-dom';
import { LBButton } from '@linearb/buzz';

const InvitationRequestExpired = ({ toggleModal }) => {
  const history = useHistory();
  return (
    <Flex items='center' direction='column'>
      <Padding t='x-large'></Padding>
      <Padding t='large'></Padding>
      <InvitationExpired fontSize='13rem'></InvitationExpired>
      <Text size='x-x-x-large' pt='2rem' weight='300'>
        Invitation request expired
      </Text>

      <Text
        size='large'
        pt='2rem'
        pl='7rem'
        pr='7rem'
        weight='400'
        align='center'
      >
        it’s been a while since this request was made, hopefully everyone has
        already joined LinearB by now
      </Text>

      <Flex direction='column' pt='x-large' b='large' items='center'>
        <LBButton
          onClick={() => {
            history.push({
              pathname: `${AppRouter.SETTINGS.path}/users`,
              search: 'isOrgSettings=true'
            });
            toggleModal();
          }}
        >
          Invite more people
        </LBButton>
        <Padding t='big'></Padding>
        <LBButton
          onClick={() => {
            history.push({
              pathname: AppRouter.PAGE_DASHBOARD.path
            });
            toggleModal();
          }}
          variant='outline'
        >
          Go to dashboard
        </LBButton>
      </Flex>
    </Flex>
  );
};

const InvitationRequestExpiredModal = ({ toggleModal }) => (
  <InvitationRequestExpired toggleModal={toggleModal} />
);

export default InvitationRequestExpiredModal;
